import React, { useEffect } from 'react';
import classes from './page-not-found.module.scss';
import { useOverlay } from '../../hooks';
import { setCustomUrlTree, setSnakbar } from '../../actions/app_action';
import { useDispatch } from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';
import { defaultUrlTree } from '../breadcrumbs-panel-dashboard/breadcrumbs-panel-dashboard';
import { withPageContainer } from '../../hoc/withPageContainer';
import PropTypes from 'prop-types';
import { Distance, Flex } from 'common/common-components.styled';
import { TooltipComponent } from 'components/tooltip-component/tooltip-component';
import IconHover from 'components/icon-hover';
import CopyIcon from 'components/icons-new/copy';

const PageNotFound = ({ containerClassName, config }) => {
  const [showOverlay, hideOverlay] = useOverlay();
  const dispatch = useDispatch();

  useEffect(() => {
    hideOverlay();
    const newUrlTree = cloneDeep(defaultUrlTree);
    newUrlTree.children = {};
    newUrlTree.title = config.pageTitle;
    dispatch(setCustomUrlTree(newUrlTree));

    return () => {
      dispatch(setCustomUrlTree(null));
    };
  }, []);

  const copyEmail = email => {
    navigator.clipboard.writeText(email);
    dispatch(
      setSnakbar({
        isOpen: true,
        message: 'Die E-Mail wurde erfolgreich kopiert.',
        type: 'success'
      })
    );
  };

  return (
    <div className={classes.page_not_found}>
      <div className={`${containerClassName} ${classes.wrapper}`}>
        <img src={config.imageSrc} alt='notFoundPage' />
        <div className={classes.container}>
          <h5>{config.subTitle}</h5>
          <h1>{config.mainTitle}</h1>
          <p className={classes.description}>{config.description}</p>
          <Flex align='center' gap='25px'>
            {config.buttons.map(button => (
              <Flex key={button.buttonText} align='center'>
                <button onClick={button.action} className='button-mobexo button-mobexo__main'>
                  {button.buttonText}
                </button>
                {button.showCopyEmailIcon && (
                  <>
                    <Distance side='10' />
                    <TooltipComponent title='E-Mail kopieren'>
                      <div>
                        <IconHover onClick={() => copyEmail(button.email)}>
                          <CopyIcon />
                        </IconHover>
                      </div>
                    </TooltipComponent>
                  </>
                )}
              </Flex>
            ))}
          </Flex>
        </div>
      </div>
    </div>
  );
};

PageNotFound.propTypes = {
  containerClassName: PropTypes.string.isRequired,
  config: PropTypes.objectOf({
    pageTitle: PropTypes.string | PropTypes.any,
    imageSrc: PropTypes.string,
    buttonText: PropTypes.string,
    subTitle: PropTypes.string,
    mainTitle: PropTypes.string,
    description: PropTypes.string,
    action: PropTypes.func
  }).isRequired
};

export default withPageContainer(PageNotFound);
